import {
  AdhocSettings,
  AdhocStatus,
  AdhocUploadFile,
  ApplicationDetails,
  ApplicationStatus,
  GenerateUploadTemplate,
  Templates,
  UploadTemplate,
  WorkflowSelection,
  ItemViewInfo,
  ItemViewSettings,
  ItemViewSetup,
} from './lazy';

const routeMap = {
  '/adhoc-settings': AdhocSettings,
  '/adhoc-application-status': AdhocStatus,
  '/adhoc-upload-file': AdhocUploadFile,
  '/application-details': ApplicationDetails,
  '/application-status/:id': ApplicationStatus,
  '/generate/upload-template': GenerateUploadTemplate,
  '/generate/templates': Templates,
  '/upload-template': UploadTemplate,
  '/workflow-selection': WorkflowSelection,
  '/new-onboarding/info': ItemViewInfo,
  '/new-onboarding/settings': ItemViewSettings,
  '/new-onboarding/setup': ItemViewSetup,
};

export default routeMap;